const pt = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Entrar',
  'nav.signOut': 'Sair',
  'nav.signingIn': 'A entrar…',
  'nav.loading': 'A carregar…',
  'nav.backToDashboard': 'Voltar ao painel',
  'nav.back': 'Voltar',
  'nav.language': 'Idioma',

  'credits.label': 'Créditos: {count}',
  'credits.loading': 'Créditos: —',
  'credits.buyMore': 'Comprar créditos',
  'credits.tooltipBuy': 'Clique para comprar mais créditos',
  'credits.tooltipLoading': 'A carregar o seu saldo de créditos',

  'auth.title': 'Entre para continuar',
  'auth.subtitle': 'Entre com a Google para receber os seus créditos gratuitos e acompanhar a sua utilização',
  'auth.google': 'Continuar com a Google',
  'auth.signOutFailed': 'Não foi possível sair. Tente novamente.',
  'auth.signInFailed': 'Não foi possível entrar. Tente novamente.',

  'landing.headline': 'Faça a fotografia que não tirou.',
  'landing.sub': 'Entre para começar. Os três primeiros créditos são por nossa conta.',
  'landing.note': 'Um crédito por imagem, cobrado apenas quando a imagem chega.',

  'dash.eyebrow': 'Ferramentas',
  'dash.headline': 'Faça a fotografia que não tirou.',
  'dash.sub': 'Escolha uma ferramenta. Cada uma custa um crédito, e só se resultar.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Mapa → vista',
  'tool.arrow.desc': 'Aponte uma seta em qualquer ponto do mapa e veja como é a vista dali.',
  'tool.person.name': 'Remover pessoas',
  'tool.person.transform': 'Multidão → vazio',
  'tool.person.desc': 'Tire os desconhecidos da fotografia e fique com o sítio onde esteve.',
  'tool.clothing.name': 'Provador virtual',
  'tool.clothing.transform': 'Peça → você',
  'tool.clothing.desc': 'Experimente uma peça antes de decidir se a compra.',

  'upload.title': 'Carregue a sua imagem',
  'upload.hint': 'Clique para escolher uma imagem ou arraste-a para aqui',
  'upload.formats': 'Formatos: JPG, PNG, GIF • Tamanho máximo: 10 MB',
  'upload.person': 'Carregar a foto da pessoa',
  'upload.clothing': 'Carregar a foto da peça',
  'upload.selectImage': 'Clique para escolher uma imagem',
  'upload.formatsShort': 'JPG, PNG — máx. 10 MB',
  'upload.tooLarge': 'A imagem tem mais de 10 MB. Escolha uma mais pequena.',
  'upload.notImage': 'Esse ficheiro não é uma imagem. Escolha um JPG ou PNG.',

  'action.generate': 'Gerar',
  'action.generating': 'A gerar…',
  'action.download': 'Transferir',
  'action.share': 'Partilhar',
  'action.delete': 'Eliminar',
  'action.cancel': 'Cancelar',
  'action.tryAgain': 'Tentar de novo',
  'action.uploadCustom': 'Carregar a sua',
  'action.browseLibrary': 'Ver a biblioteca',

  'history.show': 'Ver imagens recentes ({count})',
  'history.hide': 'Ocultar imagens recentes',
  'history.empty': 'Ainda não há nada. As suas imagens aparecerão aqui.',

  'gen.working': 'A criar a sua imagem…',
  'gen.takesTime': 'Normalmente demora menos de um minuto.',
  'gen.noCredits': 'Ficou sem créditos. Compre mais para continuar.',
  'gen.failed': 'Não resultou. O seu crédito não foi cobrado.',
  'gen.blocked': 'O filtro de segurança rejeitou essa fotografia. Tente outra: o seu crédito não foi cobrado.',

  'pay.title': 'Comprar créditos',
  'pay.subtitle': 'Os créditos não expiram.',
  'pay.creditsLabel': '{count} créditos',
  'pay.saved': 'poupa {amount}',
  'pay.pay': 'Pagar {amount}',
  'pay.processing': 'A processar…',
  'pay.success': 'Pagamento concluído. Os seus créditos foram adicionados.',
  'pay.failed': 'O pagamento falhou. Não lhe foi cobrado nada.',
  'pay.completeTitle': 'Pagamento concluído',
  'pay.completeBody': 'Os seus créditos foram adicionados à sua conta.',

  'error.title': 'Algo correu mal',
  'error.body': 'A página encontrou um erro inesperado. Recarregar costuma resolver.',
  'error.reload': 'Recarregar a página',
  'notFound.title': 'Página não encontrada',
  'notFound.body': 'Esse endereço não corresponde a nada no estúdio.',
  'notFound.home': 'Ir para o painel',

  'footer.privacy': 'Política de privacidade',
};

export default pt;
